/* eslint-disable react/require-default-props */
import React from 'react'
import {AutoApprovedFilledIcon, CircularProgressBar, HomeIcon} from '@modifi/ui'
import {landGreen, mediumGray} from '@modifi/colors'

import {HomeIconWrapper, DottedCircle, CIRCLE_SIZE} from './styles'
import {NavigationStatus} from '.'

export type ItemStatusProps = {
  status?: NavigationStatus
  progress?: number
}

const ItemStatus: React.FC<ItemStatusProps> = ({status, progress}) => {
  if (!status) {
    return (
      <HomeIconWrapper>
        <HomeIcon width={20} height={20} color={mediumGray} />
      </HomeIconWrapper>
    )
  }
  if (status === NavigationStatus.INITIAL_STATE) {
    return <DottedCircle data-ident="nav-status-tag" data-status="incomplete" />
  }
  if (status === NavigationStatus.PARTIALLY_FILLED || status === NavigationStatus.FILLED) {
    return (
      <span data-ident="nav-status-tag" data-status={progress === 100 ? 'completed' : 'incomplete'}>
        <CircularProgressBar value={progress} size={CIRCLE_SIZE} text=" " strokeWidth={12} />
      </span>
    )
  }
  return (
    <AutoApprovedFilledIcon
      color={landGreen}
      width={CIRCLE_SIZE}
      height={CIRCLE_SIZE}
      data-ident="nav-status-tag"
      data-status="approved"
    />
  )
}

export default ItemStatus
